import styled from 'vue-styled-components';
import theme from '@/config/theme';

const itemsProps = { heightItems: String };

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 0.9rem;
`;

export const SelectCustom = styled('div', itemsProps)`
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: 47px;
  line-height: 47px;
  ::-webkit-scrollbar {
    width: 80px;
  }

  & .selected {
    background-color: ${theme.colors.white};
    border-radius: 6px;
    border: 1px solid #666666;
    color: ${theme.colors.black};
    padding-left: 1em;
    cursor: pointer;
    user-select: none;

    &.open {
      border: 1px solid ${theme.colors.primaryBlue};
      border-radius: 6px 6px 0px 0px;
    }
    &::after {
      position: absolute;
      content: "";
      top: 22px;
      right: 1em;
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-color: ${theme.colors.black} transparent transparent transparent;
    }

    &.disabled {
      background-color: ${theme.colors.gray2};
      pointer-events: none;
    }
  }

  .items {
    color: ${theme.colors.black};
    border-radius: 0px 0px 6px 6px;
    overflow: hidden;
    border-right: 1px solid ${theme.colors.primaryBlue};
    border-left: 1px solid ${theme.colors.primaryBlue};
    border-bottom: 1px solid ${theme.colors.primaryBlue};
    position: absolute;
    background-color: ${theme.colors.white};
    left: 0;
    right: 0;
    z-index: 1;
    overflow-y: auto;
    max-height: ${(props) => props.heightItems ?? '189px'};

    & div {
      color: ${theme.colors.black};
      padding-left: 1em;
      cursor: pointer;
      user-select: none;

      &:hover {
        color: ${theme.colors.white};
        background-color: ${theme.colors.primaryBlue};
      }
    }
  }

  & .selectHide {
    display: none;
  }
`;
